import { Button, Row, Col, Card, Container } from 'react-bootstrap';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { messages, language } from '../../language';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const CustomAlert = ({ onClose, title, text, children }) => {
    return (
        <IntlProvider locale={language} messages={messages[language]}>
            <Card
                style={{ width: '25rem', maxHeight: '600px' }}
                className="confirmCard"
            >
                <Card.Body>
                    <Card.Text className="text-center h4 mb-3">
                        {title}
                    </Card.Text>
                    <Container fluid>
                        <Row
                            style={{
                                width: '25rem',
                                maxHeight: '300px',
                                overflow: 'scroll'
                            }}
                        ></Row>
                        <Row>
                            <Col xs={12} className="text-left">
                                <Button
                                    variant="outline-success"
                                    className="w-100"
                                    onClick={() => {
                                        onClose();
                                    }}
                                >
                                    <FormattedMessage
                                        id="Ok"
                                        defaultMessage="OK"
                                    />
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>
            </Card>
        </IntlProvider>
    );
};

export default CustomAlert;
